<template>
	<div class="main-contents prj">		
		<div class="tit">
			프로젝트 지원IT프로
			<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.go(-1)"/>
		</div>
		
		<div v-for="(project) in projectList" :key="project.projectSeq">
			<div class="prj_list-box" :ref="project.projectSeq">
				<div class="no"></div>
				<div class="view int_prj">
					<div class="req">
						<div class="top">
							<div v-if="project.projectStatus == 1" class="proc pf">수행중</div>
							<div v-else-if="project.projectStatus == 2" class="proc ep">수행예정</div>
							<div class="proc rc">모집중</div>
						</div>
						<div class="itv-outline int_prj">
							<div class="regi">
								<div class="tit int_prj">
									<div class="label">
										<p>프 로 젝 트 명</p>
									</div>
								</div>
								<div class="name" style="width: 530px;" @click="clickProjectInfo(project.projectSeq)">{{project.projectNm}}</div>
								
								<div class="sub-box">
									<div class="date_new">등록일자 {{project.regYyyymmdd}}</div>
									<!-- <div class="input"><img src="/images/admin/input_btn.png " alt="IT프로투입" @click="tecMberPut(project)"/></div> -->
								</div>
							</div>
							<div class="int_box">
								<div class="list-view int_prj">
									<div class="label">
										<p>고 객 사</p>
									</div>
									<div class="list" style="display: inline-flex; width: 540px;">
										<div style="white-space: nowrap;">{{project.clientNm}}</div>
										<div class="loca"><img src="/images/location.png" alt="위치"/>{{project.projectLocCont}}</div>
									</div>
								</div>
								<div class="list-view int_prj">
									<div class="label">
										<p>수 행 사</p>
									</div>
									<div class="list">
										<span>{{project.corpNm}}</span>
									</div>
								</div>
								<div class="list-view int_prj">
									<div class="label">
										<p>담 당 자</p>
									</div>
									<div class="list">{{project.corpMgrMberNm}}</div>
								</div>
								<div class="list-view int_prj">
									<div class="label">
										<p>개 발 기 간</p>
									</div>
									<div class="list">{{project.projectStartEndYyyymmdd}}</div>
								</div>
								<div class="list-view int_prj">
									<div class="label">
										<p>개 요</p>
									</div>
									<div class="list text">{{project.projectDtlDesc}}</div>
								</div>
								<div class="list-view int_prj">
									<div class="label">
										<p>개 발 기 술</p>
									</div>
									<div class="list text">{{project.devTechCont}}</div>
								</div>
								<div class="btn-box notice">
									<div class="btn member">
										<img src="/images/admin/prj_mb_count_01.png" alt="멤버수"/>
										<div class="number bttm10">
											<p>{{project.appMberCnt}}명</p> <!-- 합격 -->
											<p>{{project.appNotRatedCnt}}명</p>  <!-- 불합격 -->
											<p>{{project.appAprvCnt}}명</p>  <!-- 인터뷰 -->
											<p>{{project.appImpoCnt}}명</p>  <!-- 투입 -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="agent">
						<img src="/images/admin/agent_logo.png" alt="그레이트프로매니저"/>
						<p>- 그레이트프로 담당 매니저 -</p>
						<div class="name">
							<span v-if="project.admMgrMberNm" @click="popupAdmMgerMber(project.admMgrMberSeq)">{{project.admMgrMberNm}} &#9654;</span>
							<span v-else>-</span>
						</div>
						<div v-if="project.admLoginId" class="id"><p>id : </p>{{project.admLoginId}}</div>
					</div>
				</div>
			</div>

			<div class="search-box middle">
				<SelectComp type="select" class="wd05" :isAll="true" list="00:미평가,01:지원 허가,02:지원 불가" title="지원 상태" v-model="appStatusCd"/>						
				<nbsp/>
				<img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getTecMberList()"/>
			</div>

			<!-- 참여IT프로 -->
			<div class="Board type3 itv show top0">
				<table class="Board_type3 admin">
					<colgroup>   <!-- 3, 3, 5, 7, 3, 3, 6, 6, 14, 10, 15, 22 -->
						<col width="3%">
						<col width="3%">
						<col width="7%">
						<col width="7%">
						<col width="3%">
						<col width="3%">
						<col width="6%">
						<col width="6%">
						<col width="14%">
						<col width="11%">
						<col width="14%">
						<col width="22%">
					</colgroup>
					<thead>
						<tr>
							<th>선택</th>
							<th>NO</th>
							<th>평균<br/>평가등급</th>
							<th>성명</th>
							<th>성별</th>
							<th>연생</th>
							<th>기술등급<br/>(학력기준)</th>
							<th>기술등급<br/>(자격기준)</th>
							<th>소속사</th>
							<th>담당분야</th>
							<th>참여기간</th>
							<th>
								<template v-if="editable(project)">
									<SelectComp v-model="appStatDiv" list="01:지원허가,02:지원불가(불합격)" title="IT프로 상태변경" :isAll="true" />
									<img class="search_btn" src="/images/admin/modify_btn.png" alt="변경버튼" @click="btnModify(project)"/>
								</template>
								<template v-else>IT프로 상태</template>
							</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="projectTecMberList.length > 0">
							<tr v-for="(mberRow, mberIdx) in projectTecMberList" :key="mberIdx">
								<td class="radio">
									<SelectComp type="radio" v-model="selectedIndex" :list="mberRow.projectAppSeq + ':'" @change="selectedRow = mberRow"/>
								</td>
								<td class="score">{{mberIdx + 1}}</td>
								<td class="score"><gradeImg type="TOT_EVAL_ADM" :grade="mberRow.totEvalGradeCd" :specialYn="mberRow.specialGradeYn" class="gradeimg"/></td>
								<td class="score name" @click="goTecMberPage(mberRow.mberSeq)">{{mberRow.mberNm}} &#9654;</td>
								<td class="score">{{mberRow.gender | gender}}</td>
								<td class="score">{{mberRow.birthYyyymmdd | birthYear}}</td>
								<td class="score"><gradeImg type="SCHOOL_TECH_ADM" :grade="mberRow.resumeSchoolTechGradeCd"/></td>
								<td class="score"><gradeImg type="LICENSE_TECH_ADM" :grade="mberRow.resumeLicenseTechGradeCd"/></td>
								<td :class="mberRow.corpSeq != undefined? 'score':'score color-gray'">{{mberRow.corpNm}}</td>
								<td class="score">{{mberRow.workCont}}</td>
								<td class="score">{{mberRow.joinStartYyyymmdd | date('yyyy.MM.dd')}} - {{mberRow.joinEndYyyymmdd | date('yyyy.MM.dd')}}</td>
								<td class="score">
									<p v-if="mberRow.appStatusCd == '00'">미평가</p>
									<p v-if="mberRow.appStatusCd == '01'">지원허가</p>
									<gradeImg type="INTERVIEW_RES_ADM" :grade="mberRow.statusImg" v-if="mberRow.appStatusCd == '02'"/>
								</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="score" colspan="12" style="font-weight: bold; font-size: x-large;">지원IT프로 데이터가 없습니다.</td>
							</tr>
						</template>
					</tbody>
				</table>
				<!-- 20230502 테스트 : 선택한 IT프로 이력부분 다운 -->
				<!-- <div class="test-out" style="background-color:red; height:50px; margin-left:80px;">
					<div class="test-in" style="background-color:blue; height:50px; margin:0 auto; width:300px;"></div>
				</div> -->
			</div>
		</div>
	</div><!-- //main-contents -->
</template>
<script>

import gradeImg from "@/components/highpro/GradeImg.vue";

export default {
	components: { gradeImg },
	data() {
		return {
			input : {
				projectStatusAnd : 'Y',	// 프로젝트 상태 조회시 모집중 and (수행중 or 수행예정) 으로 조회하기 위한 구분값
				projectDetail: 'Y',
				projectSeq: this.$route.params.prjtSeq,
				inquryDstic: 'appMberList',
			},
			
			nowYyyymmdd : '',

			selectedIndex : '',
			intvStatDiv : '',
			appStatusCd: '', 
			appStatDiv: '',
			tecMberSeq : '',
			selectedRow : {},

			projectList : {},

			projectTecMberList : [],
			projectSeqTecMber : '',

			chgProjectSeq : this.$route.params.chgProjectSeq,
			prjtSeq: this.$route.params.prjtSeq,
		};
	},

	beforeMount() {
		// if(this.$route.name == 'PRJ911M01'){
        //     this.input.projectDivCd = '1';
        // }else{
        //     this.input.projectDivCd = '3';
        // }
	},

	mounted(){
		this.nowYyyymmdd = new Date().format("yyyyMMdd");

		var keys = Object.keys(this.input);
		for(var key in this.$route.params){
			if(keys.indexOf(key) >= 0){
				this.input[key] = this.$route.params[key];
			}
		}

		this.getList();
	},
	methods: {
        getList(isScroll = false){
			this.$.httpPost('/api/prj/adm/getProjectList', this.input)
                .then(res => {
					// console.log('res.data', res.data);

                    this.projectList = res.data.list;
					this.projectSeqTecMber = '';

					if(this.chgProjectSeq) {
						for(var i in this.projectList) {
							if(this.projectList[i].projectSeq == this.chgProjectSeq) {
								this.projectList[i].isOpenTecMber = true;
								this.projectSeqTecMber = this.chgProjectSeq
								this.getTecMberList(this.projectSeqTecMber);
							}
						}
					}else if(this.projectList.length > 0 && this.projectList[0].appMberCnt > 0) {
						// 참여IT프로 조회
						if(this.prjtSeq) {
							this.getTecMberList(this.prjtSeq);
						} else {
							this.projectList[0].isOpenTecMber = true;
							this.projectSeqTecMber = this.projectList[0].projectSeq;
							this.getTecMberList(this.projectSeqTecMber);
						}
					}

                    if(isScroll) {
						window.scroll(0, 0);
					}
				})
                .catch(err => {
					alert(err.response.data.error_description);
				});
        }, 
		
		getTecMberList(projectSeq) {
			var param = {
				projectSeq : projectSeq ? projectSeq : this.input.projectSeq,
				appStatusCd : this.appStatusCd
			};

			this.selectedIndex = '';
			this.intvStatDiv = '';
			
			this.$.httpPost('/api/prj/adm/getProjectApplyMemberList', param)
				.then(res => {
					this.projectTecMberList	= res.data.projectTecMberList;
					this.projectSeqTecMber = projectSeq;

					if(this.chgProjectSeq) {
						this.$.focus(this.$refs[this.chgProjectSeq]);
						this.chgProjectSeq = '';
					}
				}).catch(this.$.httpErrorCommon);
		},	
		
		openTecMber(project) {
			this.getTecMberList(project.projectSeq);
		},

		closeTecMber() {	
			this.projectSeqTecMber = '';		
			// this.$forceUpdate();
		},		
		
		clickProjectInfo(projectSeq) {
			var viewId = 'PRJ911M03'

			var params = {
				caller : {
					name: this.$route.name,
					params: this.input
				}
			}

			this.$router.push({name: viewId, query : {projectSeq : projectSeq}, params });

		},	

		// 프로젝트 담당 매니저 정보 보기
		popupAdmMgerMber(admMgrMberSeq) {
			var param = {};
			param.reqMberSeq = admMgrMberSeq;
			param.div = 'agt'; // tec - 개인, gmg - 관리총괄, pmg - 프로젝트 담당자, sco - 파트너사, agt - 매니저

			this.$.popup('/adm/mem/MEM923P02', param);
		},

		// 참여기간 변경
		changeJoinStartEndYyyymmdd(projectSeq, mberSeq) {
			alert('프로젝트 참여기간 변경 개발 해야 함 projectSeq : ' + projectSeq + ', mberSeq : ' + mberSeq);
		},

		// 평가보기
		viewEval(projectSeq, mberSeq) {
			alert('평가보기 개발 해야 함 projectSeq : ' + projectSeq + ', mberSeq : ' + mberSeq);
		},

		// 평가요청
		reqEval(projectSeq, mberSeq) {
			alert('평가요청 개발 해야 함 projectSeq : ' + projectSeq + ', mberSeq : ' + mberSeq);
		},
		
		// IT프로 투입 / 교체투입
		// div : 1 - 투입, 2 - 교체투입
		tecMberPut(obj) {
			var param = {};
			param.projectSeq = obj.projectSeq;
			param.div = "1";

			this.$router.push({name:'PRJ911M02', query:param, params:{projectNm:obj.projectNm, div:1}});
		},

		goTecMberPage(tecMberSeq){
			//console.log('goResume', item);
			var query = { tecMberSeq };
			var params = {
				caller : {
					name: this.$route.name,
					params: this.input,
				}
			}
			this.$router.push({name: 'PRJ911M06', query, params });
		},

		// IT프로 상태변경
		// intvStatDiv : 1 - 인터뷰 요청, 2 - 합격, 3 - 불합격, 4 - 불합격 및 교체
		btnModify(obj) {
			if(!this.editable(obj)) return alert('총괄관리자 또는 담당매니저만 IT프로 상태변경이 가능합니다.');
			if(!this.appStatDiv) {
				alert('IT프로 상태변경을 선택하세요.');
				return false;
			}

			
			if(Object.keys(this.selectedRow).length == 0) {
				alert('IT프로를 선택하세요.');
				return false;
			}

			if(this.appStatDiv == this.selectedRow.appStatusCd) {
				var statTxt = "'지원허가'";
				if(this.appStatDiv == '02') statTxt = "'지원불가'";
				
				alert('해당 IT프로는 이미 '+statTxt+' 상태 입니다.');
				return;
			}

			var param = {};
			param.projectAppSeq = this.selectedRow.projectAppSeq;
			param.appStatusCd = this.appStatDiv;

			if(confirm('지원상태를 변경하시겠습까?')) {
				this.$.httpPost('/api/prj/adm/updateAppStatusCd', param)
				.then(() => {
					this.getTecMberList(this.prjtSeq);
				})
				.catch(this.$.httpErrorCommon);
			}
		},

		getProjectMberCnt(seq) {
			this.$.httpPost('/api/prj/adm/getProjectMberCnt', {projectSeq : seq})
				.then(res => {
					for(var i in this.projectList) {
						if(this.projectList[i].projectSeq == seq) {
							this.projectList[i].passMberCnt = res.data.passMberCnt;
							this.projectList[i].mberCntFail = res.data.mberCntFail;
							this.projectList[i].mberCntInterview = res.data.mberCntInterview;
							this.projectList[i].inputMberCnt = res.data.inputMberCnt;
						}
					}

				}).catch(this.$.httpErrorCommon);
		},

		editable(project){
			return this.$store.state.userInfo.mberDivCd == '00'				//총괄관리자
				|| this.$store.state.userInfo.mberSeq == project.admMgrMberSeq;//담당매니저
		}
	},
};
</script>
<style scoped>
.bttm10 p {
	margin-bottom:10px!important;
}
</style>